import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Circle, Path } from '../IconBase/IconBase'

const Group = ({
  color = 'icon.primary',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) => (
  <IconBase viewBox='0 0 18 20' fill='none' {...props}>
    <Circle
      cx='3.5'
      cy='16.5'
      r='2.5'
      stroke={color}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
      fill={fill}
    />
    <Circle
      cx='9'
      cy='3.5'
      r='2.5'
      stroke={color}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
      fill={fill}
    />
    <Circle
      cx='14.5'
      cy='16.5'
      r='2.5'
      stroke={color}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
      fill={fill}
    />
    <Path
      d='M14.5 14V12C14.5 10.8954 13.6046 10 12.5 10H5.5C4.39543 10 3.5 10.8954 3.5 12V14'
      stroke={color}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
      fill='transparent'
    />
    <Path
      d='M9 6V10'
      stroke={color}
      strokeWidth={strokeWidth}
      stroke-linecap='round'
      stroke-linejoin='round'
      fill={fill}
    />
  </IconBase>
)

Group.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Group
